import { IconSummary } from "..";
import { IconButtonContainer, IconButtonProps } from "./IconButtonContainer";

export default function IconButtonSummary(props: IconButtonProps) {
    return <IconButtonContainer {...props}>
        <IconSummary />
    </IconButtonContainer>
}
